import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { api, ApiError } from "../../lib/api";
import { AuthLayout } from "./Login";

/* Forgot password — single email field. The API always returns 200
   (prevents email enumeration), so the success message is shown
   whether the email is registered or not. */
export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Couldn't send reset email. Try again.");
    } finally {
      setBusy(false);
    }
  };

  if (sent) {
    return (
      <AuthLayout title="Check your email" subtitle="If we have an account for that email, a reset link is on its way.">
        <div className="text-center">
          <CheckCircle2 className="w-10 h-10 text-green-600 mx-auto mb-3" />
          <p className="text-sm text-slate-700">
            We sent a password-reset link to <span className="font-semibold">{email}</span>.
          </p>
          <p className="text-xs text-slate-500 mt-2">
            The link expires in 1 hour. If you don't see it, check spam.
          </p>
          <Link to="/portal-x7k3" className="inline-block mt-6 text-sm text-blue-600 hover:text-blue-800">
            Back to sign in
          </Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Forgot your password?" subtitle="We'll email you a reset link.">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-xs font-medium text-slate-600 mb-1.5 block">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
            className="w-full text-sm rounded-lg ring-1 ring-inset ring-slate-300 px-3 py-2.5 focus:outline-none focus:ring-blue-500"
          />
        </div>
        {error && (
          <div className="text-sm text-red-700 bg-red-50 ring-1 ring-red-200 rounded-lg px-3 py-2">
            {error}
          </div>
        )}
        <button
          type="submit"
          disabled={busy}
          className="w-full bg-[#162a52] hover:bg-[#0f1f3d] disabled:opacity-60 text-white font-semibold rounded-lg px-4 py-2.5 text-sm inline-flex items-center justify-center gap-2"
        >
          {busy && <Loader2 className="w-4 h-4 animate-spin" />}
          {busy ? "Sending…" : "Send reset link"}
        </button>
        <div className="text-center">
          <Link to="/portal-x7k3" className="text-xs text-blue-600 hover:text-blue-800">
            Back to sign in
          </Link>
        </div>
      </form>
    </AuthLayout>
  );
}
export default ForgotPassword;
